export class RemoveRedline {
    constructor() {
        this.separatorClass = 'separator';
        this.ctaInformationClass = 'cta-large.cta-large--without-bg';
        this.ctaFooterClass = 'site-footer';
        this.ctaNewsletterClass = 'newsletter.cta-newsletter';
        this.init();
    }
    init() {
        let ctaInfo = document.querySelector('.'+this.ctaInformationClass);
        let ctaFooter = document.querySelector('.'+this.ctaFooterClass);
        let ctaNewsletter = document.querySelector('.'+this.ctaNewsletterClass);
        const numberOfSeparator = document.querySelectorAll('.'+this.separatorClass);
        for(let x = 0; x < numberOfSeparator.length; x++) {
            if(ctaInfo && ctaInfo.previousElementSibling && ctaInfo.previousElementSibling.classList.contains(this.separatorClass)) {
                let element = document.querySelector('.vertical-links');
                if(element)
                    element.style.marginBottom = "0px";
                ctaInfo.parentElement.removeChild(ctaInfo.previousElementSibling);
            }
            if(ctaFooter && ctaFooter.previousElementSibling && ctaFooter.previousElementSibling.classList.contains(this.separatorClass)) {
                console.log('test');
                ctaFooter.parentElement.removeChild(ctaFooter.previousElementSibling);
            }
            if(ctaNewsletter && ctaNewsletter.previousElementSibling && ctaNewsletter.previousElementSibling.classList.contains(this.separatorClass)) {
                ctaNewsletter.parentElement.removeChild(ctaNewsletter.previousElementSibling);
            }
        }
    }
}
